import 'jquery-lazyload/jquery.lazyload';

$(document).on('turbolinks:load', function() {
  $('.lazyload').lazyload();
});
